import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

// The provider acknowledges that a youth LEC removed from the periode is gone: the row leaves
// its placement list. Mirrors the centers' acknowledge-enrollment-removal.
export const acknowledgeOtoIndividualEnrollmentRemoval = async (input: {
  enrollmentId: number
}) => {
  const { enrollmentId } = input
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.acknowledgeOtoIndividualEnrollmentRemoval.url, {
        enrollmentId
      })
    )
    .post()
}
